<template>
    <div class="image-container" v-if="array.length && array[0].image != null">
        <img :src="`${this.$store.state.base_directory}${array[0].image.replace(/^public\//, '')}`" alt="Изображение">
    </div>
    <section class="article__container" v-for="item in array">
            <article>
                <h1>{{ item.title}}</h1>
                
                <div class="meta" v-if="item.author && item.published_at">
                    <p>{{ item.author}}</p>
                    <p>{{ item.published_at }}</p>
                </div>
                <template v-for="value in item.content">
                    <h2 v-if="value.element_type == 'h2'">{{ value.text }}</h2>
                    <template v-else-if="value.element_type == 'p'"><p v-html="value.text"></p></template>
                    <img v-else :src="`${this.$store.state.base_directory}${value.content_field.replace(/^public\//, '')}`" alt="Industrial Crane">
                </template>
                </article>
        </section>
</template>

<script>
    export default {
        props: {
            array: [Array, Object],
        },
    }
</script>

<style scoped>
.article__container{
    display: flex;
    flex-direction: column;
    align-items: center;
}
 h1 {
/* Header/H2: 32px Medium */
    color: rgb(15, 28, 55);
    font-size: 32px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding-bottom: 44px;
}
.meta{
    display: flex;
    justify-content: space-between;
    color: rgb(15, 28, 55);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    margin-bottom: 40px;
}
.meta > p{
    color: rgb(15, 28, 55);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
}
h2 {
    color: rgb(15, 28, 55);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding-bottom: 16px;
    padding-top: 64px;
}
h2:first-of-type{
    padding-top: unset;
}
p{
    color: rgb(85, 98, 114);
    font-size: 20px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
article{
    max-width: 640px;
}
article img {
    width: 100%;
    height: auto;
    margin-top: 64px;
}
.image-container {
    width: 100%;
    max-height: 480px;
    height: 50vh;
    margin-bottom: 50px;
}

.image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

@media (max-width: 768px) {
    .image-container {
        max-height: 400px;
    }
}

@media (max-width: 480px) {
    .image-container {
        max-height: 200px;
    }
}
</style>